export default __webpack_public_path__ + "static/char-31-anr-5f670f540459f7d6aedd8179548a8987.gif";